import React, {useState, useEffect} from 'react';
import { Timeline } from 'antd';
import moment from 'moment';
import dot_main from '../../assets/images/ico-timeline-main.svg'
import dot_sub from '../../assets/images/ico-timeline-sub.svg'
import TimelineCardWithThumbnail from "./cardNews/TimelineCardWithThumbnail";
import TimelineCard from "./cardNews/TimelineCard";
import {getSimilarNewsAPI} from '../../apis/news_service'

const RecentlTimeline = ({news}) => {

    const palete = [
        'rgba(239,243,255,1)','rgba(241,239,255,1)','rgba(236,250,243,1)','rgba(235,250,242,1)',
        '#fdf8f4', '#fcfdf4', '#f7f7f7',
        'rgba(92,105,120,0.05)','rgba(117,176,249,0.05)','rgba(190,216,247,0.05)','rgba(12,62,122,0.05)','rgba(145,165,189,0.05)',
    ]

    const [originNews, setOriginNews] = useState(news)  //부모뉴스 리스트
    const [relatedNews, setRelatedNews] = useState([]); //자식뉴스
    const [similarNewsId, setSimilarNewsId] = useState([]); // 부모뉴스Id 배열

    const getRelatedNews = () => {
        const newsList = []
        originNews.map(el => {
            getSimilarNewsAPI(el.newsid, el.samenewscounts)
                .then(res => {
                    if(!!res) {newsList.push(...res)}
                    return newsList
                })
                .then(res => {
                    const sortedNews = res.sort((a, b) => dateFormatter(a.registdate).diff( dateFormatter(b.registdate)))
                    setRelatedNews([...sortedNews])
                })
        })
    }

    useEffect(()=>{
        const newsId = originNews.filter(el=> el.samenewscounts > 0).map(el => el.similarnewsid)
        setSimilarNewsId([...new Set(newsId)])
        getRelatedNews()
    },[originNews])


    const colorPicker = (id) => {
        const colorIdx = similarNewsId.indexOf(id)
        if(colorIdx === -1){
            return ''
        }
        return palete[colorIdx]
    }

    const dateFormatter = (date) => {
        const day = date.slice(0,10)
        const midday = date.slice(12,14) === '오전' ? 0 : 12
        const hour = Number(date.slice(14,17)) + midday
        const min =  date.slice(18)

        return moment(`${day} ${hour}:${min}`)
    }
    return (
        <div  className='timeline_recent' >
            <Timeline
                mode="right" //left, right, alternate
                items={[...news.map(el => {
                    return {
                        dot: <img src={dot_main} alt='dot'/>,
                        children: <TimelineCardWithThumbnail news={el} main='' color={colorPicker(el.similarnewsid)}/>,
                    }
                }),
                    {
                    dot: <img src={dot_main} alt='dot'/>,
                    children: '',
                    }
                ]}
            />

            {!!relatedNews &&
                <Timeline
                    mode="left" //left, right, alternate
                    items={[...relatedNews.map(el => {
                        return (
                            {
                                dot: <img src={dot_sub} alt='dot'/>,
                                children: <TimelineCard news={el} main='' color={colorPicker(el.similarnewsid)}/>,
                            }
                        )
                    }), {dot: <img src={dot_sub} alt='dot'/>, children: '',}]}
                />}
        </div>

    );
};

export default RecentlTimeline;

